import {
  Card,
  Row,
  Col,
  Spin,
  Alert,
  // Progress
} from "antd";
import {
  ShoppingCartOutlined,
  CheckCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import { useGetDailyOrdersQuery } from "@/services/api/dashboard/dashboardApi";

const DailyOrders = () => {
  const {
    data: dailyOrders,
    isLoading: dailyOrdersLoading,
    error: dailyOrdersError,
    refetch: refetchingDailyOrders,
  } = useGetDailyOrdersQuery();

  // Mock data for bar chart
  const mergeDailyOrdersData = (apiData, limit = 12) => {
    return apiData?.current_month.slice(0, limit).map((currentDay) => {
      // Extract just the day number for comparison
      const currentDayNumber = parseInt(currentDay.day.split(" ")[1]);

      const prevDay = apiData?.previous_month.find(
        (prev) => parseInt(prev.day.split(" ")[1]) === currentDayNumber
      );

      return {
        day: currentDay.day,
        orders: currentDay.total_orders,
        prev: prevDay ? prevDay.total_orders : 0,
      };
    });
  };
  const dailyOrdersData = mergeDailyOrdersData(dailyOrders, 12);

  // Mock data for line charts

  // Custom tooltip for bar chart
  const CustomBarTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-black p-2 rounded shadow-lg">
          <p className="font-medium text-white mb-2">{`${label}`}</p>
          {payload.map((entry, index) => (
            <div className="flex gap-2" key={index}>
              <div
                className="p-1 h-4 w-4 rounded"
                style={{ backgroundColor: entry.color }}
              ></div>
              <p className="text-sm text-white">
                {`${entry.name}: ${entry.value} orders`}
              </p>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };
  return (
    <Card
      title="Daily Orders"
      className="h-full shadow-sm border border-gray-100"
    >
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} lg={24}>
          <div className="h-64">
            {dailyOrdersLoading ? (
              <div className="flex items-center justify-center h-full">
                <Spin size="large" />
              </div>
            ) : dailyOrdersError ? (
              <div className="flex items-center justify-center h-full p-4">
                <Alert
                  message="Error"
                  description={
                    dailyOrdersError?.data?.message || "Failed to load data."
                  }
                  type="error"
                  showIcon
                  action={
                    <button
                      onClick={refetchingDailyOrders}
                      className="text-sm underline"
                    >
                      Retry
                    </button>
                  }
                />
              </div>
            ) : (
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={dailyOrdersData}>
                  <XAxis
                    dataKey="day"
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: "0.5rem", fill: "#6b7280" }}
                  />
                  <YAxis hide />
                  <Tooltip content={<CustomBarTooltip />} />
                  <Legend />
                  <Bar
                    dataKey="orders"
                    name="Current Orders"
                    stackId="a"
                    fill="#D06D01"
                    radius={[0, 0, 4, 4]}
                  />
                  <Bar
                    dataKey="prev"
                    name="Previous Month"
                    stackId="a"
                    fill="#F9A022"
                    radius={[4, 4, 0, 0]}
                  />
                </BarChart>
              </ResponsiveContainer>
            )}
          </div>
        </Col>
        {/* <Col xs={8} lg={6}>
          <div className="space-y-6 ">

            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center">
                  <ShoppingCartOutlined className="text-orange-600" />
                </div>
                <div>
                  <div className="text-sm font-medium text-gray-500">
                    <span className="block">New Orders</span>
                    <span className=" block text-sm font-bold text-gray-900">
                      234
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-between ">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-yellow-100 rounded-full flex items-center justify-center">
                  <SyncOutlined className="text-yellow-600" />
                </div>
                <div>
                  <div className="text-sm font-medium text-gray-500">
                    <span className="block">Processing</span>
                    <span className=" block text-sm font-bold text-gray-900">
                      120
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                  <CheckCircleOutlined className="text-green-600" />
                </div>
                <div>
                  <div className="text-sm font-medium text-gray-500">
                    <span className="block">Completed</span>
                    <span className=" block text-sm font-bold text-gray-900">
                      345
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col> */}
      </Row>
    </Card>
  );
};
export default DailyOrders;
